// login.js
import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ASSISTANT_AUTH_LOGIN_URL /*, ASSISTANT_AUTH_GOOGLE_URL, ASSISTANT_AUTH_MICROSOFT_URL */ } from '../constants';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Ruta original desde la que fue redirigido al login
  const redirectPath = location.state?.from?.pathname || '/admin';

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);

    try {
      const payload = {
        email: formData.email.trim().toLowerCase(),
        password: formData.password,
      };

      const res = await axios.post(ASSISTANT_AUTH_LOGIN_URL, payload, { withCredentials: true });
      const { token, username } = res.data || {};

      if (token) {
        try {
          login(token, username);
        } catch {
          login(token);
          if (username) localStorage.setItem('username', username);
        }

        navigate(redirectPath, { replace: true });
      } else {
        setError('Inicio de sesión fallido. Inténtalo de nuevo.');
      }
    } catch (err) {
      console.error('Error de solicitud:', err.response ? err.response.data : err.message);
      setError(err.response?.data?.msg || 'Ocurrió un error. Inténtalo de nuevo.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white shadow-md rounded-lg">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-900">Login Admin UNIMEL</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Correo electrónico</label>
            <input
              type="email"
              name="email"
              placeholder="correo@ejemplo.com"
              autoComplete="username"
              value={formData.email}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Contraseña</label>
            <input
              type="password"
              name="password"
              placeholder="Tu contraseña"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md shadow-sm hover:bg-indigo-700 disabled:opacity-70 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {submitting ? 'Ingresando…' : 'Entrar'}
          </button>
        </form>

        <div className="mt-3 text-right">
          <Link to="/recover" className="text-sm text-indigo-600 hover:underline">
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            ¿No tienes cuenta?
            <Link to="/error" className="text-indigo-600 hover:underline"> Regístrate</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;